import React from 'react';
import { ClientServiceSelect } from './index.client';
import { cmsClient } from '../../graphql';
import type { ServicesQuery, ServicesQueryVariables } from '../../graphql/generated/schema';
import { SERVICES } from '../../graphql/query/service';

export const ServiceSelect: React.FC = async () => {
  const services = await cmsClient.request<ServicesQuery, ServicesQueryVariables>(SERVICES, {
    limit: 10,
    page: 1,
    sort: 'title',
  }).catch(() => ({ Services: { docs: [] } }));

  if (!services.Services?.docs?.length) {
    return null;
  }

  return (
    <ClientServiceSelect
      services={services.Services?.docs?.map((service) => ({
        title: service?.title || '',
        slug: service?.slug || '',
        shortTitle: service?.shortTitle || '',
      })) || []}
    />
  );
};
